import { render, staticRenderFns } from "./scoreStudent.vue?vue&type=template&id=c0ded864"
import script from "./scoreStudent.vue?vue&type=script&lang=js"
export * from "./scoreStudent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports